import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import CommonButton from "../../../../components/buttons/CommonButton";
import CommonInputValor from "../../../../components/forms/CommonInputValor";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../../helpers/handleFormChanges";
import CommonInputDate from "../../../../components/forms/CommonInputDate";
import PropTypes from "prop-types";

function PagarImpostoModal({
  modalHook,
  valuesHook,
  pagarImposto,
  cancelarPagamentoImposto,
}) {
  const { pagarImpostoModal, setPagarImpostoModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Pagamento de imposto"
      is_open_modal={pagarImpostoModal}
      set_is_open_modal={setPagarImpostoModal}
      size="md"
      buttons={
        <CommonButton
          key={`alterar-pagamento`}
          onClick={() => {
            values.pago ? cancelarPagamentoImposto() : pagarImposto();
          }}
          color={values.pago ? "primary" : "success"}
        >
          {values.pago ? "Cancelar pagamento" : "Informar pagamento"}
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-12 mb-3">
          <CommonInputValor
            label="Valor pago"
            id="valor"
            value={values.valor}
            onChange={(e) => {
              handleChangeNameValue("valor", e.target.value, values, setValues);
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-3">
          <CommonInputDate
            label="Data de pagamento"
            id="dataPagamento"
            value={values.dataPagamento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

PagarImpostoModal.propTypes = {
  modalHook: PropTypes.shape({
    pagarImpostoModal: PropTypes.bool.isRequired,
    setPagarImpostoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  pagarImposto: PropTypes.func.isRequired,
  cancelarPagamentoImposto: PropTypes.func.isRequired,
};

export default PagarImpostoModal;
